import styled, { css } from "styled-components"

import {
  Color,
  IsMobile,
  IsPC,
  LineHeight,
  RadiusSize,
  Shadow,
  SpacingSize,
  TextSize,
  Transition,
  Z,
} from "~/consts/style-mixins"
import { staticPath } from "~/services/helper"

export const NewGradScoutCorpContactContainer = styled.div`
  position: relative;
  overflow: hidden;
  ${IsPC(css`
    margin-top: 69px;
  `)};
  div,
  p {
    line-height: 140%;
  }
`

export const Section = styled.section`
  position: relative;
  .decoration {
    position: absolute;
    z-index: 1;
    &.d1 {
      bottom: 28px;
      ${IsMobile(css`
        width: 140px;
        bottom: -36px;
        left: -20px;
      `)};
    }
    &.d3 {
      width: 266px;
      top: -152px;
      right: -37px;
      ${IsMobile(css`
        width: 107px;
        top: -57px;
        right: -5px;
      `)};
    }
    &.d4 {
      width: 164px;
      top: 40px;
      right: 40px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d5 {
      width: 294px;
      bottom: 35px;
      left: 10px;
      ${IsMobile(css`
        width: 124px;
        bottom: -17px;
        left: 10px;
      `)};
    }
    &.d6 {
      width: 222px;
      bottom: -72px;
      left: -26px;
      ${IsMobile(css`
        width: 88px;
        bottom: -68px;
        right: -5px;
      `)};
    }
    &.d7 {
      width: 273px;
      top: 42px;
      left: 20px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d8 {
      width: 245px;
      top: 520px;
      right: 35px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d9 {
      width: 157px;
      bottom: -113px;
      right: 98px;
      ${IsMobile(css`
        width: 72px;
        bottom: -86px;
        right: 6px;
      `)};
    }
    &.d10 {
      width: 222px;
      top: 549px;
      left: 94px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d11 {
      width: 160px;
      top: 652px;
      left: 22px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.d12 {
      width: 150px;
      top: 36px;
      right: 32px;
      ${IsMobile(css`
        width: 75px;
        top: 60px;
        right: 11px;
      `)};
    }
    &.d13 {
      width: 389px;
      top: -40px;
      left: -10px;
      ${IsMobile(css`
        width: 153px;
        top: -50px;
        left: -16px;
      `)};
    }
  }
  .decoration-line {
    position: absolute;
    z-index: 0;
    &.ll {
      width: 375px;
    }
    &.ls {
      width: 144px;
    }
    &.l1 {
      top: 48px;
      right: 50px;
      ${IsMobile(css`
        top: auto;
        bottom: 0px;
        right: -170px;
      `)};
    }
    &.l2 {
      top: -50px;
      left: -45px;
      ${IsMobile(css`
        top: 0px;
        left: -78px;
      `)};
    }
    &.l3 {
      top: 450px;
      right: 0;
      ${IsMobile(css`
        /* bottom: 0px; */
        right: -272px;
      `)};
    }
    &.l5 {
      bottom: 164px;
      right: 150px;
      ${IsMobile(css`
        top: 500px;
        bottom: auto;
        right: 0px;
      `)};
    }
    &.l6 {
      bottom: 0px;
      left: 150px;
      ${IsMobile(css`
        bottom: 0px;
        left: 20px;
      `)};
    }
    &.l7 {
      top: 138px;
      right: 0px;
      ${IsMobile(css`
        top: 134px;
        right: -100px;
      `)};
    }
    &.l8 {
      bottom: 320px;
      right: 0px;
      ${IsMobile(css`
        bottom: 420px;
        right: -50px;
      `)};
    }
    &.l9 {
      bottom: 146px;
      right: 70px;
      ${IsMobile(css`
        bottom: 290px;
        right: 20px;
      `)};
    }
    &.l10 {
      bottom: 570px;
      left: 33px;
      ${IsMobile(css`
        bottom: 608px;
        left: -180px;
      `)};
    }
    &.l11 {
      bottom: 0px;
      right: -100px;
      ${IsMobile(css`
        bottom: -84px;
        right: -150px;
      `)};
    }
    &.l12 {
      bottom: 116px;
      left: 23px;
      ${IsMobile(css`
        bottom: 10px;
        left: 23px;
      `)};
    }
    &.l13 {
      top: 0x;
      right: 144px;
      ${IsMobile(css`
        top: 43px;
        right: 0px;
      `)};
    }
    &.l14 {
      bottom: 466px;
      right: 100px;
      ${IsMobile(css`
        display: none;
      `)};
    }
    &.l15 {
      bottom: 0px;
      left: 170px;
      ${IsMobile(css`
        bottom: 0px;
        right: 15px;
      `)};
    }
  }
`

export const HeadingContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-weight: bold;
  ${IsMobile(css`
    flex-direction: column;
  `)};
  .heading-icon-number {
    display: flex;
    align-items: center;
    ${IsMobile(css`
      margin-bottom: 10px;
    `)};
  }
  .heading-icon {
    position: relative;
    top: -6px;
    ${IsMobile(css`
      width: 32px;
    `)};
  }
  .heading-number {
    margin: 0 8px 0 12px;
    font-size: 60px;
    color: ${Color.Primary};
    ${IsMobile(css`
      font-size: 40px;
    `)};
  }
  .heading-text {
    font-size: 26px;
    ${IsMobile(css`
      font-size: 19px;
      text-align: center;
    `)};
  }
`

interface CvAppealContainerProps {
  bgImgSrc: string
}

export const CvAppealContainer = styled.div<CvAppealContainerProps>`
  max-height: 184px;
  margin: 60px 0;
  z-index: 1;
  cursor: pointer;
  ${IsMobile(css`
    width: 100%;
    max-width: inherit;
    margin: 30px 0;
  `)};
  .cv-appeal-content {
    padding-right: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-image: radial-gradient(
      63.25% 142.74% at 100% 9.78%,
      rgba(108, 84, 255, 0.9) 32.33%,
      rgba(23, 164, 255, 0.9) 100%
    );
    overflow: hidden;
    ${Shadow.Deep};
    border-radius: ${RadiusSize.Medium}px;
    ${IsMobile(css`
      padding-right: 0;
    `)}
    ${({ bgImgSrc }: CvAppealContainerProps) => css`
      ${IsMobile(`
        background-image: url(${staticPath(`${bgImgSrc}`)});
      `)}
    `}
  }
  .cv-appeal-content_img {
    width: 496px;
  }
  .cv-appeal-content_inner {
    text-align: center;
    padding: 0 20px;
    margin: auto;
    ${IsMobile(css`
      width: 100%;
      padding: 32px 12px;
      background: radial-gradient(
        97.6% 215.39% at 100% 9.78%,
        rgba(108, 84, 255, 0.9) 32.33%,
        rgba(23, 164, 255, 0.9) 100%
      );
    `)};
  }
  .cv-appeal-content_message {
    font-size: 18px;
    font-weight: bold;
    color: ${Color.White};
    margin-bottom: ${SpacingSize.M}px;
    text-shadow: 0px 0px 20px rgb(0 0 0 / 15%);
    ${IsMobile(css`
      font-size: 13px;
    `)}
  }
  .cv-appeal-content_button {
    max-width: 260px;
    margin: auto;
    background: ${Color.White};
    color: ${Color.LpPrimary};
    box-shadow: 0 5px 0 ${Color.LpPrimary};
    &:hover {
      ${IsPC(css`
        box-shadow: none;
        transform: translateY(5px);
      `)};
    }
  }
`

export const PcHeaderContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  background-color: ${Color.White};
  border-bottom: 1px solid ${Color.BorderGray};
  z-index: ${Z.Header};
  .pc-header-inner {
    padding: ${SpacingSize.M}px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .pc-header-inner_logo-area {
    height: 32px;
  }
  .pc-header-inner_center {
    font-size: ${TextSize.S}px;
    font-weight: bold;
    color: ${Color.Gray};
    margin-left: auto;
    padding: 0 ${SpacingSize.S}px;
  }
  .pc-header-inner_right {
    display: flex;
    align-items: center;
  }
  .pc-header-inner_link {
    font-size: ${TextSize.S}px;
    font-weight: bold;
    color: ${Color.Gray};
    text-decoration: none;
    ${Transition.Hover};
    margin-right: ${SpacingSize.XS}px;
    &:hover {
      color: ${Color.Black};
    }
  }
  .pc-header-inner_tel {
    font-size: ${TextSize.S}px;
    font-weight: bold;
    color: ${Color.Gray};
    margin-right: ${SpacingSize.XS}px;
  }
  .pc-header-inner_button {
    width: 200px;
    background-color: ${Color.LpPrimary};
    &:hover {
      background-color: ${Color.LpPrimaryDark};
    }
  }
`

export const FixBottomContainer = styled.div`
  position: fixed;
  width: 100%;
  bottom: -1px;
  border-bottom: 1px solid ${Color.BorderGray};
  z-index: ${Z.Header};
  ${Shadow.Deep};
  .fix-bottom-inner {
    display: flex;
    padding-bottom: env(safe-area-inset-bottom);
    background: linear-gradient(
      90deg,
      ${Color.White} 0%,
      ${Color.White} 50%,
      ${Color.LpPrimary} 50%,
      ${Color.LpPrimary} 100%
    );
  }
  .fix-bottom-inner_item {
    padding: 18px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    font-size: ${TextSize.M}px;
    font-weight: bold;
  }
  .fix-bottom-inner_item-icon {
    width: 20px;
    margin-right: ${SpacingSize.XS}px;
  }
  .fix-bottom-inner_item-tel {
    color: ${Color.Primary};
  }
  .fix-bottom-inner_item-cv {
    color: ${Color.White};
  }
`

export const MainVisualContainer = styled.div`
  background: ${Color.BackgroundGray};
  padding-top: ${SpacingSize["4XL"]}px;
  ${IsMobile(css`
    padding-top: 0;
  `)};
  .inner {
    position: relative;
    display: flex;
    height: 560px;
    align-items: center;
    background-image: url(${staticPath("/static/images/new-grad-scout/corp-contact/mv-bg.png")});
    background-position: top right;
    background-size: cover;
    background-repeat: no-repeat;
    ${IsMobile(`
      height: 535px;
      align-items: flex-start;
      background-image: url(${staticPath("/static/images/new-grad-scout/corp-contact/mv-bg-sp.png")});
      background-size: cover;
      background-position-x: center;
    `)}
  }
  .mv-mask {
    position: absolute;
    top: 0;
    right: 0;
    height: 560px;
    user-drag: none;
    ${IsMobile(css`
      height: 500px;
      top: 0;
      right: -32px;
    `)};
  }
  .mv-decoration-bold-line {
    position: absolute;
    top: 76px;
    right: 84px;
    user-drag: none;
    ${IsMobile(css`
      height: 71px;
      top: 24px;
      left: -92px;
    `)};
  }
  .mv-decoration-line {
    position: absolute;
    top: 0;
    right: 30px;
    height: 283px;
    user-drag: none;
    ${IsMobile(css`
      left: -92px;
    `)};
  }
  .mv-feature-circles {
    position: absolute;
    bottom: -25px;
    right: 12%;
    width: 354px;
    user-drag: none;
    ${IsMobile(css`
      width: 334px;
      bottom: 135px;
      left: 50%;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
    `)}
  }
  .container {
    width: 100%;
    ${IsMobile(css`
      margin-top: 135px;
    `)}
  }
  .hero {
    font-size: 44px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    color: ${Color.White};
    ${IsMobile(css`
      font-size: clamp(12px, 6vw, 32px);
    `)}
  }
  .supplement {
    margin-top: ${SpacingSize.XS}px;
    font-size: ${TextSize.M}px;
    line-height: ${LineHeight.M}%;
    font-weight: bold;
    color: ${Color.White};
    ${IsMobile(css`
      font-size: 12px;
    `)}
  }
  .mv-button {
    max-width: 260px;
    width: 100%;
    margin-top: ${SpacingSize["4XL"]}px;
    background-color: ${Color.LpPrimary};
    box-shadow: 0 5px 0 ${Color.LpPrimaryDark};
    ${IsMobile(css`
      position: absolute;
      bottom: 56px;
      left: 50%;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
    `)};
    &:hover {
      ${IsPC(css`
        box-shadow: none;
        transform: translateY(5px);
      `)};
    }
  }
`

export const FeatureContainer = styled.div`
  padding: 48px 0 64px;
  ${IsMobile(css`
    padding: 0 0 30px;
  `)}
  .what-is {
    position: relative;
    width: 80%;
    height: 232px;
    margin-bottom: 48px;
    padding-left: 200px;
    background-color: ${Color.BackgroundPrimary};
    float: right;
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border-right: 150px solid transparent;
      border-top: 232px solid ${Color.White};
    }
    ${IsMobile(css`
      width: 100%;
      height: 165px;
      padding: 0 20px;
      text-align: center;
      float: none;
      &:before {
        display: none;
      }
    `)}
  }
  .what-is-heading {
    margin: 44px 0 22px;
    padding-bottom: 4px;
    display: inline-block;
    font-size: 30px;
    font-weight: bold;
    line-height: 140%;
    color: ${Color.Primary};
    border-bottom: 3px solid ${Color.Primary};
    ${IsMobile(css`
      margin-top: 30px;
      font-size: 21px;
    `)}
  }
  .what-is-description {
    margin-left: 56px;
    font-size: 18px;
    font-weight: bold;
    line-height: 180%;
    ${IsMobile(css`
      margin-left: 0;
      font-size: 13px;
    `)}
  }
  .section-container {
    position: relative;
    z-index: 0;
    clear: both;
  }
  .heading-2 {
    margin-bottom: 30px;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    &.green {
      color: ${Color.Primary};
    }
    &.large {
      font-size: 50px;
    }
    ${IsMobile(css`
      font-size: 21px;
      line-height: 110%;
      &.large {
        font-size: 33px;
      }
    `)}
  }
  .feature-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    ${IsMobile(css`
      flex-direction: column;
    `)};
  }
  .feature-item-second-third-container {
    display: flex;
    ${IsMobile(css`
      position: relative;
      bottom: 34px;
    `)};
  }
  .feature-item {
    width: 290px;
    height: 290px;
    padding: 22px 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    text-align: center;
    color: ${Color.Primary};
    border: 1px solid ${Color.Primary};
    border-radius: 50%;
    cursor: pointer;
    ${IsMobile(css`
      padding: 10px 0 10px;
    `)};
    &.first {
      position: relative;
      left: 30px;
      ${IsMobile(css`
        left: inherit;
      `)};
    }
    &.second {
      ${IsMobile(css`
        position: relative;
        left: 6px;
      `)};
    }
    &.third {
      position: relative;
      right: 30px;
      ${IsMobile(css`
        right: 6px;
      `)};
    }
    ${IsMobile(css`
      width: 180px;
      height: 180px;
    `)};
  }
  .feature-item-point-text {
    font-size: 12px;
    ${IsMobile(css`
      font-size: 10px;
    `)};
  }
  .feature-item-point-number {
    font-size: 30px;
    ${IsMobile(css`
      font-size: 21px;
      line-height: 100%;
    `)};
  }
  .feature-item-description {
    margin-bottom: 10px;
    font-size: 18px;
    line-height: 140%;
    ${IsMobile(css`
      margin-bottom: 4px;
      font-size: 12px;
    `)};
  }
  .feature-illustration {
    &.first {
      width: 140px;
      ${IsMobile(css`
        width: 93px;
      `)};
    }
    &.second {
      width: 113px;
      ${IsMobile(css`
        width: 78px;
      `)};
    }
    &.third {
      width: 112px;
      ${IsMobile(css`
        width: 108px;
      `)};
    }
  }
  .feature-arrow {
    margin-top: 8px;
    ${IsMobile(css`
      width: 12px;
      margin-top: 0;
    `)};
  }
`

export const FeaturePointFirstContainer = styled.div`
  background: ${Color.BackgroundGray};
  padding: 96px 0;
  ${IsMobile(css`
    padding: 48px 0;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .point-list {
    margin: 0 auto 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${IsMobile(css`
      flex-direction: column;
    `)}
  }
  .point-list-item {
    width: 240px;
    height: 305px;
    margin-right: 12px;
    font-weight: bold;
    text-align: center;
    background-color: ${Color.White};
    ${IsMobile(css`
      width: 100%;
      margin: 0 0 18px 0;
    `)}
    &:last-child {
      margin-right: 0;
      ${IsMobile(css`
        margin-bottom: 0;
      `)}
    }
  }
  .point-list-item-heading {
    height: 25px;
    font-size: 15px;
    line-height: 26px;
    color: ${Color.White};
    background-color: ${Color.Primary};
  }
  .point-list-item-content {
    height: 280px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .point-list-item-img-wrapper {
    height: 192px;
    padding-top: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .point-list-item-img {
    &.first {
      width: 104px;
    }
    &.second {
      width: 211px;
    }
    &.third {
      width: 205px;
    }
    &.forth {
      width: 187px;
    }
  }
  .point-list-item-description {
    height: 82px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    line-height: 150%;
  }
  .feature-point-1-appeal-above {
    position: relative;
    width: 524px;
    margin: 0 auto 36px;
    padding: 12px 0 10px;
    font-size: 25px;
    font-weight: bold;
    color: ${Color.White};
    text-align: center;
    background-color: ${Color.Primary};
    ${IsMobile(css`
      width: 100%;
      margin-bottom: 14px;
      font-size: 18px;
    `)}
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border: none;
      border-left: solid 35px ${Color.BackgroundGray};
      border-bottom: solid 57px transparent;
    }
    &:after {
      position: absolute;
      content: "";
      right: 0px;
      top: 0;
      width: 0;
      height: 0;
      border: none;
      border-left: solid 35px transparent;
      border-bottom: solid 57px ${Color.BackgroundGray};
    }
  }
  .feature-point-1-appeal-above-pseudo-element:before {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    left: 0;
    width: 0px;
    height: 0px;
    margin: auto;
    border-style: solid;
    border-color: ${Color.BackgroundGray} transparent transparent transparent;
    border-width: 12px 12px 0 12px;
    ${IsMobile(css`
      border-width: 8px 8px 0 8px;
    `)}
  }
  .feature-point-1-appeal-below {
    text-align: center;
  }
  .feature-point-1-appeal-below-text {
    display: inline-block;
    font-size: 25px;
    line-height: 200%;
    border-bottom: 2px solid ${Color.Primary};
    ${IsMobile(css`
      font-size: 18px;
    `)}
    &.green {
      font-weight: bold;
      color: ${Color.Primary};
    }
  }
  .question-container {
    position: relative;
    border: 1px solid ${Color.Primary};
    &:before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 0;
      height: 0;
      border-right: 64px solid transparent;
      border-top: 64px solid ${Color.Primary};
      ${IsMobile(`
        border-right: 40px solid transparent;
        border-top: 40px solid ${Color.Primary};
      `)}
    }
  }
  .question-heading {
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    text-align: center;
    color: ${Color.Primary};
    border-bottom: 1px solid ${Color.Primary};
  }
  .question-heading-sub-text {
    margin-bottom: 8px;
    font-size: 15px;
    ${IsMobile(css`
      font-size: 12px;
    `)}
  }
  .question-heading-text {
    font-size: 24px;
    ${IsMobile(css`
      font-size: 18px;
    `)}
  }
  .question-content {
    height: 280px;
    padding: 40px 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${IsMobile(css`
      height: inherit;
      padding: 30px 20px;
      flex-direction: column;
    `)}
    &:first-child {
      border-bottom: 1px solid ${Color.Primary};
    }
  }
  .question-content-img {
    width: 320px;
    margin-right: 82px;
    ${IsMobile(css`
      width: 260px;
      margin: 0 0 24px 0;
    `)}
  }
  .question-content-heading {
    margin-bottom: 12px;
    font-size: 20px;
    font-weight: bold;
    ${IsMobile(css`
      font-size: 14px;
    `)}
  }
  .question-content-text {
    font-size: 14px;
    line-height: 180%;
    ${IsMobile(css`
      font-size: 12px;
    `)}
  }
`

export const FeaturePointSecondContainer = styled.div`
  background: ${Color.White};
  padding: 96px 0 0;
  ${IsMobile(css`
    padding: 48px 0 12px;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .service-system-table {
    margin-bottom: 48px;
  }
  .service-system-table-heading {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: ${Color.White};
    background-color: ${Color.Primary};
    ${IsMobile(css`
      padding: 8px 14px 6px;
      font-size: 13px;
    `)}
  }
  .service-system-table-content {
    height: 198px;
    padding: 32px 44px;
    display: flex;
    align-items: center;
    ${IsMobile(css`
      height: inherit;
      padding: 20px 12px;
      flex-direction: column;
    `)}
    &.green {
      background-color: ${Color.BackgroundPrimary};
    }
  }
  .service-system-table-content-img {
    width: 425px;
    margin-right: 45px;
    ${IsMobile(css`
      width: 100%;
      margin-right: 0;
    `)}
  }
  .service-system-table-content-description {
    font-size: 14px;
    line-height: 180%;
    ${IsMobile(css`
      font-size: 12px;
    `)}
    .green {
      margin-bottom: 2px;
      font-weight: bold;
      color: ${Color.Primary};
    }
    .large {
      margin-bottom: 6px;
      font-weight: bold;
      font-size: 18px;
      ${IsMobile(css`
        font-size: 14px;
      `)}
    }
  }
  .guarantee-container {
    text-align: center;
  }
  .guarantee-heading {
    position: relative;
    margin-bottom: 18px;
    padding-bottom: 8px;
    display: inline-block;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 2px solid ${Color.Primary};
    ${IsMobile(css`
      font-size: 13px;
    `)}
    .large {
      font-size: 40px;
      ${IsMobile(css`
        font-size: 29px;
      `)}
    }
    .green {
      color: ${Color.Primary};
    }
    &:before {
      content: "";
      display: block;
      width: 26px;
      height: 2px;
      background-color: ${Color.Primary};
      position: absolute;
      bottom: -11px;
      left: 150px;
      transform: rotate(45deg);
      z-index: 1;
      ${IsMobile(css`
        left: 104px;
      `)}
    }
    &:after {
      content: "";
      display: block;
      width: 20px;
      height: 6px;
      background-color: ${Color.White};
      position: absolute;
      bottom: -4px;
      left: 155px;
      ${IsMobile(css`
        left: 109px;
      `)}
    }
  }
  .guarantee-description {
    margin-bottom: 8px;
    font-size: 25px;
    line-height: 180%;
    ${IsMobile(css`
      font-size: 18px;
    `)}
  }
  .guarantee-price {
    font-size: 25px;
    font-weight: bold;
    ${IsMobile(css`
      font-size: 18px;
      line-height: 180%;
    `)}
    .green {
      color: ${Color.Primary};
    }
  }
`

export const FeaturePointThirdContainer = styled.div`
  background: ${Color.BackgroundGray};
  padding: 96px 0 48px;
  ${IsMobile(css`
    padding: 48px 0 12px;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .targetting-heading {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: ${Color.White};
    background-color: ${Color.Primary};
    ${IsMobile(css`
      padding: 8px 14px 6px;
      font-size: 13px;
    `)}
  }
  .targetting-content {
    padding-top: 40px;
    display: flex;
    align-items: top;
    ${IsMobile(css`
      padding-top: 24px;
      flex-direction: column;
    `)}
  }
  .targetting-content-item {
    &.first {
      width: 430px;
      margin-right: 30px;
      ${IsMobile(css`
        width: 100%;
      `)}
    }
    &.second {
      width: 100%;
      max-width: 570px;
    }
  }
  .targetting-content-item-heading {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: bold;
    line-height: 180%;
    color: ${Color.Primary};
    ${IsMobile(css`
      font-size: 14px;
    `)}
    &.underline {
      position: relative;
      margin-bottom: 32px;
      padding-bottom: 2px;
      display: flex;
      align-items: center;
      border-bottom: 2px solid ${Color.Primary};
      &:before {
        content: "";
        display: block;
        width: 26px;
        height: 2px;
        background-color: ${Color.Primary};
        position: absolute;
        bottom: -11px;
        left: 55px;
        transform: rotate(45deg);
        z-index: 1;
      }
      &:after {
        content: "";
        display: block;
        width: 20px;
        height: 6px;
        background-color: ${Color.White};
        position: absolute;
        bottom: -4px;
        left: 60px;
      }
    }
  }
  .targetting-content-item-description {
    font-size: 14px;
    line-height: 180%;
    ${IsMobile(css`
      font-size: 12px;
      margin-bottom: 16px;
    `)}
  }
  .targetting-content-item-img {
    text-align: center;
    img {
      width: 294px;
      ${IsMobile(css`
        width: 268px;
      `)}
    }
  }
  .targetting-content-search {
    display: flex;
    flex-wrap: wrap;
  }
  .targetting-content-search-item-wrapper {
    width: 50%;
    ${IsMobile(css`
      width: 100%;
    `)}
    &:first-child {
      padding-right: 10px;
    }
  }
  .targetting-content-search-item {
    height: 70px;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 160%;
    background-color: ${Color.White};
    &:last-child {
      margin-bottom: 0;
    }
  }
  .targetting-content-search-item-img {
    margin-right: 10px;
  }
`

export const SeminarContainer = styled.div`
  background: ${Color.White};
  padding: 96px 0 48px;
  ${IsMobile(css`
    padding: 48px 0 12px;
  `)}
  .section-container {
    position: relative;
    z-index: 0;
  }
  .seminar-heading-container {
    margin-bottom: 42px;
    text-align: center;
    line-height: 200%;
  }
  .seminar-heading-more {
    font-size: 55px;
    font-weight: bold;
    ${IsMobile(css`
      font-size: 36px;
    `)}
  }
  .seminar-heading-main-text {
    margin-bottom: 18px;
    font-size: 25px;
    ${IsMobile(css`
      font-size: 16px;
    `)}
  }
  .seminar-heading-main-text-each {
    display: inline-block;
    line-height: 200%;
    border-bottom: 2px solid ${Color.Primary};
    .green {
      font-weight: bold;
      color: ${Color.Primary};
    }
  }
  .seminar-heading-sub-text {
    font-size: 14px;
    ${IsMobile(css`
      font-size: 10px;
    `)}
  }
  .seminar-introduction-heading {
    margin-bottom: 40px;
    font-weight: bold;
    &:after {
      display: block;
      content: "";
      height: 3px;
      width: 60px;
      background: ${Color.Primary};
      border-radius: 3px;
      margin: ${SpacingSize.M}px auto 0 0;
    }
  }
  .seminar-introduction-heading-sub-text {
    margin-bottom: 8px;
    font-size: 14px;
    color: ${Color.Primary};
  }
  .seminar-introduction-heading-main-text {
    font-size: 24px;
    line-height: 140%;
    ${IsMobile(css`
      font-size: 18px;
    `)}
  }
  .seminar-introduction-item {
    margin-bottom: 58px;
    display: flex;
    ${IsMobile(css`
      margin-bottom: 18px;
      flex-direction: column;
    `)}
  }
  .seminar-introduction-item-content {
    position: relative;
    min-width: 634px;
    padding: 48px 76px;
    border: 2px solid ${Color.Primary};
    border-radius: 8px;
    ${IsMobile(css`
      width: 100%;
      min-width: inherit;
      padding: 40px 30px 20px;
    `)}
    &.right {
      right: 50px;
      ${IsMobile(css`
        right: inherit;
      `)}
      &:before {
        position: absolute;
        content: "";
        right: 0;
        top: 0;
        width: 0;
        height: 0;
        border-left: 64px solid transparent;
        border-top: 64px solid ${Color.Primary};
        ${IsMobile(`
          left: 0;
          right: inherit;
          border-left: none;
          border-right: 46px solid transparent;
          border-top: 46px solid ${Color.Primary};
        `)}
      }
    }
    &.left {
      &:before {
        position: absolute;
        content: "";
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        border-right: 46px solid transparent;
        border-top: 46px solid ${Color.Primary};
      }
    }
  }
  .seminar-introduction-item-content-heading {
    margin-bottom: 10px;
    font-size: 22px;
    font-weight: bold;
    color: ${Color.Primary};
    ${IsMobile(css`
      font-size: 18px;
    `)}
  }
  .seminar-introduction-item-content-description {
    font-size: 14px;
    line-height: 160%;
    ${IsMobile(css`
      margin-bottom: 14px;
      font-size: 12px;
    `)}
  }
  .seminar-introduction-item-img {
    position: relative;
    top: 34px;
    width: 400px;
    z-index: 1;
    ${IsMobile(css`
      width: 100%;
      top: inherit;
    `)}
    &.right {
      right: 50px;
      ${IsMobile(css`
        right: inherit;
      `)}
    }
  }
`
